import styles from './featured-articles-nav.module.scss';
import React, { FunctionComponent } from 'react';

export interface IFeaturedArticlesNavProps {
  title: string;
  items: number[];
  activeArticle: number;
  changeArticleHandler: (event: React.MouseEvent<HTMLElement>) => void;
}

export const FeaturedArticlesNav: FunctionComponent<IFeaturedArticlesNavProps> = props => {
  const { title, items, activeArticle, changeArticleHandler } = props;

  const formatNavItemText = (itemIndex: number): string =>
    `0${(itemIndex + 1).toString()}`;

  return (
    <div className={styles.container}>
      <div className={styles.navWrapper}>
        <span>{title}</span>
        <div className={styles.navList}>
          {items.map(item => (
            <span
              onClick={changeArticleHandler}
              data-index={item}
              key={item}
              className={`${styles.navItem} ${activeArticle === item &&
                styles.active}`}
            >
              {formatNavItemText(item)}
              <div className={styles.separator}></div>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
